import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { Button } from './ui/button';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL || '';
const VALID_FILENAME = 'AUTO_THURM_ADMIN.key';

export default function USBKeyAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  // Check existing auth on mount
  useEffect(() => {
    const token = sessionStorage.getItem('usbAdminToken');
    if (token) {
      fetch(`${API}/admin/verify`, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(res => {
        if (res.ok) setIsAuthenticated(true);
        else {
          sessionStorage.removeItem('usbAdminToken');
          localStorage.removeItem('adminToken');
        }
      }).catch(() => {});
    }
  }, []);

  // Setup drag and drop
  useEffect(() => {
    const processFile = async (file) => {
      if (file.name !== VALID_FILENAME) return;
      
      try {
        const text = await file.text();
        const data = JSON.parse(text);
        
        if (data.type !== 'auto-thurm-admin-key' || !data.key) return;

        const res = await fetch(`${API}/admin/usb-auth`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ key: data.key })
        });

        if (res.ok) {
          const result = await res.json();
          sessionStorage.setItem('usbAdminToken', result.token);
          localStorage.setItem('adminToken', result.token);
          setIsAuthenticated(true);
          toast.success('Admin-Zugang aktiviert!');
        } else {
          toast.error('Ungültiger Schlüssel');
        }
      } catch (e) {
        console.error('USB Auth Error:', e);
        toast.error('Fehler beim Lesen der Datei');
      }
    };

    const onDrop = (e) => {
      e.preventDefault();
      const file = e.dataTransfer?.files?.[0];
      if (file) processFile(file);
    };

    const onDragOver = (e) => e.preventDefault();

    window.addEventListener('drop', onDrop, true);
    window.addEventListener('dragover', onDragOver, true);

    return () => {
      window.removeEventListener('drop', onDrop, true);
      window.removeEventListener('dragover', onDragOver, true);
    };
  }, []);

  const logout = () => {
    sessionStorage.removeItem('usbAdminToken');
    localStorage.removeItem('adminToken');
    setIsAuthenticated(false);
    toast.info('Abgemeldet');
  };

  if (!isAuthenticated) return null;

  return (
    <div className="fixed bottom-4 left-4 z-50 flex flex-col gap-2">
      <Button
        onClick={() => navigate('/admin/dashboard')}
        className="bg-[#000000] hover:bg-[#1e293b] text-white shadow-none"
      >
        <Shield className="w-4 h-4 mr-2" />
        Zum Admin-Bereich
      </Button>
      <Button onClick={logout} variant="outline" size="sm" className="text-xs">
        Abmelden
      </Button>
    </div>
  );
}
